import { stationUserService } from '../../../services/StationUser'
import {
  ActionsUnion,
  IOrganizationTeamMember,
  IOrganizationTeamMemberInvite,
  IOrganizationTeamMemberWithUserResponse,
  IStateOrganizationTeamMember,
  StateOrganizationTeamMemberMap,
  StateUserMap,
  StateUserRoleMap,
  IOrganizationTeamMemberUpdateDTO,
  IStationUserUpdateDTO,
  IMemberFilters,
  IStationUserSearchObject,
  IStationUserInvite,
  IZoneObject,
  IStationUserZoneObject
} from '../../../types'
import { IAction, Id, IMap } from '../../../types/common'
import * as constants from '../../constants'
import { createAction } from '../helpers'
;(window as any).stationUserService = stationUserService

export type IStationUserAction = ActionsUnion<typeof actionCreators>

export const actionCreators = {
  //Async action creators
  stationUserListRequest: () => createAction(constants.STATION_USER_LIST_REQUEST),
  stationUserListSuccess: (payload: { total: number; items: IStationUserSearchObject[] }) =>
    createAction(constants.STATION_USER_LIST_SUCCESS, payload),
  stationUserListFail: (error: string) => createAction(constants.STATION_USER_LIST_FAIL, error),

  createStationUserRequest: () => createAction(constants.CREATE_STATION_USER_REQUEST),
  createStationUserSuccess: (teamMember: IStationUserSearchObject) =>
    createAction(constants.CREATE_STATION_USER_SUCCESS, teamMember),
  createStationUserFail: (error: string) => createAction(constants.CREATE_STATION_USER_FAIL, error),

  fetchTeamMemberRequest: () => createAction(constants.STATION_USER_FETCH_REQUEST),
  fetchTeamMemberSuccess: (payload: IStationUserSearchObject) =>
    createAction(constants.STATION_USER_FETCH_SUCCESS, payload),
  fetchTeamMemberFail: (error: string) => createAction(constants.STATION_USER_FETCH_FAIL, error),

  stationUserUpdateRequest: () => createAction(constants.STATION_USER_UPDATE_REQUEST),
  stationUserUpdateSuccess: (teamMember: IStationUserSearchObject) =>
    createAction(constants.STATION_USER_UPDATE_SUCCESS, teamMember),
  stationUserUpdateFail: (error: string) => createAction(constants.STATION_USER_UPDATE_FAIL, error),

  stationUserArchiveRequest: () => createAction(constants.STATION_USER_ARCHIVE_REQUEST),
  stationUserArchiveSuccess: (teamMember: IStateOrganizationTeamMember) =>
    createAction(constants.STATION_USER_ARCHIVE_SUCCESS, teamMember),
  stationUserArchiveFail: (error: string) => createAction(constants.STATION_USER_ARCHIVE_FAIL, error),

  teamMemberRestoreRequest: () => createAction(constants.STATION_USER_RESTORE_REQUEST),
  teamMemberRestoreSuccess: (teamMember: IStateOrganizationTeamMember) =>
    createAction(constants.STATION_USER_RESTORE_SUCCESS, teamMember),
  teamMemberRestoreFail: (error: string) => createAction(constants.STATION_USER_RESTORE_FAIL, error),

  stationUserGetGoinzoneRequest: () => createAction(constants.STATION_USER_GET_GOINZONE_REQUEST),
  stationUserGetGoinzoneSuccess: (data: IMap<IStationUserZoneObject>) =>
    createAction(constants.STATION_USER_GET_GOINZONE_SUCCESS, data),
  stationUserGetGoinzoneFailure: (error: string) => createAction(constants.STATION_USER_GET_GOINZONE_FAIL, error),
  stationUserCreateSetFetching: (fetching: boolean) => createAction(constants.STATION_USER_EDIT_SET_FETCHING, fetching),

  createGoinzoneRequest: () => createAction(constants.CREATE_GOINZONE_REQUEST),
  createGoinzoneSuccess: () => createAction(constants.CREATE_GOINZONE_SUCCESS),
  createGoinzoneFailure: (error: string) => createAction(constants.CREATE_GOINZONE_FAIL, error),

  removeGoinzoneRequest: () => createAction(constants.REMOVE_GOINZONE_REQUEST),
  removeGoinzoneSuccess: () => createAction(constants.REMOVE_GOINZONE_SUCCESS),
  removeGoinzoneFailure: (error: string) => createAction(constants.REMOVE_GOINZONE_FAIL, error),

  updateGoinzoneRequest: () => createAction(constants.UPDATE_GOINZONE_REQUEST),
  updateGoinzoneSuccess: () => createAction(constants.UPDATE_GOINZONE_SUCCESS),
  updateGoinzoneFailure: (error: string) => createAction(constants.UPDATE_GOINZONE_FAIL, error),

  serviceCreateSetStepCompleted: (step: number, completed: boolean) =>
    createAction(constants.SERVICE_EDIT_SET_COMPLETED, { step, completed })
}

export function fetchStationUserList(filters: IMemberFilters): any {
  const { stationUserListRequest, stationUserListSuccess, stationUserListFail } = actionCreators
  return (dispatch: any) => {
    dispatch(stationUserListRequest())
    return stationUserService.fetchStationUserList(filters).then(
      (payload: { total: number; items: IStationUserSearchObject[] }) => {
        dispatch(stationUserListSuccess(payload))
        return payload
      },
      error => {
        return dispatch(stationUserListFail(error))
      }
    )
  }
}

export const createStationUser = (teamMember: IStationUserInvite) => async (dispatch: any) => {
  const { createStationUserRequest, createStationUserSuccess, createStationUserFail } = actionCreators
  dispatch(createStationUserRequest())
  return stationUserService.createStationUser(teamMember).then(
    teamMember => {
      dispatch(createStationUserSuccess(teamMember))
      return teamMember
    },
    data => {
      return dispatch(createStationUserFail(data))
    }
  )
}

export const fetchStationUser = (id: Id) => async (dispatch: any) => {
  const { fetchTeamMemberRequest, fetchTeamMemberSuccess, fetchTeamMemberFail } = actionCreators
  dispatch(fetchTeamMemberRequest())
  try {
    const response = await stationUserService.fetchStationUser(id)
    dispatch(fetchTeamMemberSuccess(response))
    return response
  } catch (e) {
    return dispatch(fetchTeamMemberFail(e.message))
  }
}

export const updateStationUser = (teamMember: IStationUserUpdateDTO) => (dispatch: any) => {
  const { stationUserUpdateRequest, stationUserUpdateSuccess, stationUserUpdateFail } = actionCreators
  dispatch(stationUserUpdateRequest())
  return stationUserService.updateOneStationUser(teamMember).then(
    teamMember => {
      dispatch(stationUserUpdateSuccess(teamMember))
      return teamMember
    },
    ({ data }) => {
      return dispatch(stationUserUpdateFail(data))
    }
  )
}

export const moveToArchive = (teamMember: IStationUserSearchObject) => (dispatch: any) => {
  const { stationUserArchiveRequest, stationUserArchiveSuccess, stationUserArchiveFail } = actionCreators
  dispatch(stationUserArchiveRequest())
  return stationUserService.moveToArchiveStationUser(teamMember).then(
    teamMember => {
      dispatch(stationUserArchiveSuccess(teamMember))
      return teamMember
    },
    ({ data }) => {
      dispatch(stationUserArchiveFail(data))
    }
  )
}

export const restoreFromArchive = (teamMember: IStationUserSearchObject) => (dispatch: any) => {
  const { teamMemberRestoreRequest, teamMemberRestoreSuccess, teamMemberRestoreFail } = actionCreators
  dispatch(teamMemberRestoreRequest())
  return stationUserService.restoreFromArchive(teamMember).then(
    teamMember => {
      dispatch(teamMemberRestoreSuccess(teamMember))
      return teamMember
    },
    ({ data }) => {
      dispatch(teamMemberRestoreFail(data))
    }
  )
}

export function getGoinzones(stationUserId: string) {
  const {
    stationUserGetGoinzoneRequest,
    stationUserGetGoinzoneSuccess,
    stationUserGetGoinzoneFailure,
    stationUserCreateSetFetching
  } = actionCreators
  return (dispatch: any) => {
    dispatch(stationUserGetGoinzoneRequest())
    dispatch(stationUserCreateSetFetching(true))
    return stationUserService.getGoinzones(stationUserId).then(
      (zones: any) => {
        const zonesObj: IMap<IStationUserZoneObject> = {}
        zones.stationUserZones.map((z: any) => {
          if (z.id) {
            zonesObj[z.id] = z
          }
        })
        dispatch(stationUserGetGoinzoneSuccess(zonesObj))
        dispatch(stationUserCreateSetFetching(false))
        return
      },
      (error: any) => dispatch(stationUserGetGoinzoneFailure(error.data))
    )
  }
}

export function enableButtons(flag: boolean) {
  const { stationUserCreateSetFetching } = actionCreators
  return (dispatch: any) => {
    dispatch(stationUserCreateSetFetching(flag))
  }
}

export function createGoinzones(goinzone: IStationUserZoneObject) {
  const {
    createGoinzoneRequest,
    createGoinzoneSuccess,
    createGoinzoneFailure,
    serviceCreateSetStepCompleted
  } = actionCreators
  return (dispatch: any) => {
    dispatch(createGoinzoneRequest())
    return stationUserService.createGoinzone(goinzone).then(
      () => {
        dispatch(createGoinzoneSuccess())
        dispatch(serviceCreateSetStepCompleted(3, true))
        return
      },
      (error: any) => dispatch(createGoinzoneFailure(error.data))
    )
  }
}

export function removeGoinzone(id: string) {
  const { removeGoinzoneRequest, removeGoinzoneSuccess, removeGoinzoneFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(removeGoinzoneRequest())
    return stationUserService.removeGoinzone(id).then(
      () => {
        dispatch(removeGoinzoneSuccess())
        return
      },
      (error: any) => dispatch(removeGoinzoneFailure(error.data))
    )
  }
}

export function updateGoinzone(goinzone: IStationUserZoneObject) {
  const { updateGoinzoneRequest, updateGoinzoneSuccess, updateGoinzoneFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(updateGoinzoneRequest())
    return stationUserService.updateGoinzone(goinzone).then(
      () => {
        dispatch(updateGoinzoneSuccess())
        return
      },
      (error: any) => dispatch(updateGoinzoneFailure(error.data))
    )
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/station-user/index.ts